<template>
  <div>
    <div class="mybooking-online">
      <b-card v-if="request_quotation != null">
        <div class="float-left">
          <a v-if="!isShow" @click="processFiles" class="btn round btn-success pl-2 pr-2 mr-1"><feather-icon
              icon="CheckSquareIcon" />
            {{ $t("Submit") }}
          </a>
          <a v-if="!isShow" @click="handSaveDraft" class="btn btn-success round pl-2 pr-2 mr-1"><feather-icon
              icon="SaveIcon" /> {{
                  $t("saveDraft")
              }}
          </a>
          <a @click="handIsDraft" v-if="
            (!$Utils.isBlank(tempDraftKH) &&
              (userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Client ||
                userData.userType ==
                $Utils.CONSTANTS.USER_TYPE_O.Client_Root)) ||
            (!$Utils.isBlank(tempDraftAdmin) &&
              userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin) ||
            (!$Utils.isBlank(tempDraftSALE) &&
              userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin_Sale) && !isShow
          " class="btn btn-secondary round pl-2 pr-2 mx-auto float-right"><feather-icon
              :icon="viewDraft ? 'XIcon' : 'BookmarkIcon'" />
            {{ $t("viewDraft") }}
          </a>
          <a @click="generateReport" class="btn round btn-success pl-2 pr-2 mr-1"><feather-icon icon="SendIcon" />
            Preview (PDF)</a>
        </div>
      </b-card>
      <div>
        <vue-perfect-scrollbar :settings="{
          maxScrollbarLength: 150,
          suppressScrollX: true,
        }" style="height: 70vh" class="scrollable-container scroll-area">
          <b-card>
            <validation-observer>
              <div>
                <b-row>
                  <b-col cols="12" lg="6">
                    <div>
                      <span>
                        <!-- secondary -->
                      </span>
                      <b-row>
                        <b-col cols="12" class="mb-2">
                          <div>
                            <label>Shipper</label>
                            <Select4 v-model="shipper.shipperSelected" @select="shipper_selected" :disabled="isShow"
                              placeholder="Select Company" :options="{
                                value: 'code',
                                label: 'text',
                                data: companyItems,
                                fields: [
                                  { field: 'code', label: 'Tax Code' },
                              
                                  { field: 'name', label: 'Name' },
                                  {
                                    field: 'acronym',
                                    label: 'Acronym',
                                  },
                                ],
                              }" />
                          </div>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group>
                            <b-form-textarea rows="12" :disabled="isShow" v-model="shipper.notes"
                              placeholder="Enter Company"></b-form-textarea>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                    <div>
                      <span>
                        <!-- secondary -->
                      </span>
                      <b-row>
                        <b-col cols="12" class="mb-2">
                          <div>
                            <label>Consignee</label>
                            <Select4 v-model="consignee.consigneeSelected" @select="consignee_selected"
                              placeholder="Select Company" :disabled="isShow" :options="{
                                value: 'code',
                                label: 'text',
                                data: companyItems,
                                fields: [
                                  { field: 'code', label: 'Tax Code' },
                              
                                  { field: 'name', label: 'Name' },
                                  {
                                    field: 'acronym',
                                    label: 'Acronym',
                                  },
                                ],
                              }" />
                          </div>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group>
                            <b-form-textarea rows="12" v-model="consignee.notes" :disabled="isShow"
                              placeholder="Enter Company"></b-form-textarea>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                    <div>
                      <b-row>
                        <b-col cols="12" lg="9">
                          <div>
                            <label el>Notify</label>

                            <Select4 v-model="notify.notifySelected" :disabled="notify.notifyCopy || isShow"
                              @select="notify_selected" placeholder="Notify" :options="{
                                value: 'code',
                                label: 'text',
                                data: companyItems,
                                fields: [
                                  { field: 'code', label: 'Tax Code' },
                              
                                  { field: 'name', label: 'Name' },
                                  {
                                    field: 'acronym',
                                    label: 'Acronym',
                                  },
                                ],
                              }" />
                          </div>
                        </b-col>
                        <b-col cols="3" md="3" lg="1">
                          <b-form-checkbox style="
                              display: flex;
                              justify-content: center;
                              top: 2.5rem;
                            " :disabled="
                              consignee.consigneeSelected && !isShow
                                ? false
                                : true
                            " v-model="notify.notifyCopy">
                            Copy
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <b-form-group>
                            <b-form-textarea :disabled="isShow" rows="12" v-model="notify.notes"
                              placeholder="Enter Company"></b-form-textarea>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                    <div>
                      <vue-good-table :columns="columns" :rows="rows_ship_table">
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field === 'region'">
                            <Select2 placeholder="Select Shipper" style="width: 300px" :disabled="isShow"
                              v-model="props.row[props.column.field]" @change="
                                changeCellShipTable(
                                  props.row[props.column.field],
                                  props.column.field,
                                  props.row.originalIndex
                                )
                              " :settings="{
  allowClear: true,
}" :options="countries" />
                          </span>
                          <span v-else-if="props.column.field === 'pic'">
                            <b-form-input v-model="props.row[props.column.field]" :disabled="isShow" @change="
                              changeCellShipTable(
                                props.row[props.column.field],
                                props.column.field,
                                props.row.originalIndex
                              )
                            " type="text"></b-form-input>
                          </span>

                          <span v-else-if="props.column.field === 'tel'">
                            <b-form-input v-model="props.row[props.column.field]" :disabled="isShow" @change="
                              changeCellShipTable(
                                props.row[props.column.field],
                                props.column.field,
                                props.row.originalIndex
                              )
                            " type="text"></b-form-input>
                          </span>

                          <span v-else-if="props.column.field === 'email'">
                            <b-form-input v-model="props.row[props.column.field]" :disabled="isShow" @change="
                              changeCellShipTable(
                                props.row[props.column.field],
                                props.column.field,
                                props.row.originalIndex
                              )
                            " type="text"></b-form-input>
                          </span>
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <!-- Vessel & Voyage -->
                    <div>
                      <span>Vessel & Voyage</span>
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox plain name="checkbox-input" :disabled="isShow" style="cursor: pointer"
                              v-b-tooltip.hover class="pull-up custom-control-primary" title="
                               Other
                              " @change="
                                () => {
                                  shipping.vessel = '';
                                }
                              " v-model="shipping.vesselIsInput"></b-form-checkbox>
                          </b-input-group-prepend>
                          <b-form-input v-if="shipping.vesselIsInput" :disabled="isShow"
                            placeholder="Enter Vessel & Voyage" v-model="shipping.vessel" />

                          <Select4 v-else v-model="shipping.vessel" class="input-sec" :disabled="isShow" style="
                              position: relative;
                              flex: 1 1 auto;
                              min-width: 0;
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                            " placeholder="Choose Port of Discharge" :options="{
                              value: 'id',
                              label: 'name',
                              data: vessel,
                              hide: true,
                              fields: [{ field: 'name', label: 'Name' }],
                            }" />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <!-- Shipping Term -->
                    <div>
                      <label>Shipping Term</label>
                      <b-form-group class="w-100">
                        <!-- <v-select
                            placeholder="Choose Port of Discharge"
                            v-model="shipping.shippingTerm"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="text"
                            :options="incoterms"
                          /> -->
                        <Select4 :disabled="isShow" v-model="shipping.shippingTerm" style="
                            position: relative;
                            flex: 1 1 auto;
                            min-width: 0;
                            border-top-left-radius: 0;
                            border-bottom-left-radius: 0;
                          " placeholder="Choose Port of Discharge" :options="{
                            value: 'code',
                            label: 'name',
                            data: incoterms,
                            fields: [{ field: 'name', label: 'Name' }],
                          }" />
                      </b-form-group>
                    </div>

                    <!-- Place of Receipt -->
                    <div>
                      <label>Place of Receipt</label>

                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox plain name="checkbox-input" :disabled="isShow" style="cursor: pointer"
                              v-b-tooltip.hover class="pull-up custom-control-primary" title="
                              Other
                              " @change="
                                () => {
                                  shipping.placeOfReceipt = '';
                                }
                              " v-model="shipping.placeOfReceiptIsInput"></b-form-checkbox>
                          </b-input-group-prepend>
                          <b-form-input :disabled="isShow" v-if="shipping.placeOfReceiptIsInput"
                            placeholder="Enter Place of Receipt" v-model="shipping.placeOfReceipt" />

                          <Select4 v-else v-model="shipping.placeOfReceipt" :disabled="isShow" style="
                              position: relative;
                              flex: 1 1 auto;
                              min-width: 0;
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                            " class="input-sec" placeholder="Choose Place of Receipt" :options="{
                              value: 'code',
                              label: 'name',
                              data: ports,
                              fields: [
                                { field: 'code', label: 'Code' },
                                { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                                {
                                  field: 'country_code',
                                  label: 'Country Code',
                                },
                              ],
                            }" />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <!-- Port of Loading -->
                    <div>
                      <label>POL</label>

                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox plain :disabled="isShow" name="checkbox-input" style="cursor: pointer"
                              v-b-tooltip.hover class="pull-up custom-control-primary" title="
                              Other
                              " @change="
                                () => {
                                  shipping.pol = '';
                                }
                              " v-model="shipping.portOfLoadingIsInput"></b-form-checkbox>
                          </b-input-group-prepend>
                          <b-form-input v-if="shipping.portOfLoadingIsInput" :disabled="isShow" placeholder="Enter POL"
                            v-model="shipping.pol" />

                          <Select4 v-else v-model="shipping.pol" :disabled="isShow" style="
                              position: relative;
                              flex: 1 1 auto;
                              min-width: 0;
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                            " class="input-sec" placeholder="Choose POL" :options="{
                              value: 'code',
                              label: 'name',
                              data: ports,
                              fields: [
                                { field: 'code', label: 'Code' },
                                { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                                {
                                  field: 'country_code',
                                  label: 'Country Code',
                                },
                              ],
                            }" />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <!-- Port of Discharge -->
                    <div>
                      <label>POD</label>
                      <!-- <b-form-group class="w-100">
                        <b-form-select
                          v-model="shipping.portOfDischarge"
                          :options="discharge"
                          placeholder="POD"
                        />
                      </b-form-group> -->

                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox :disabled="isShow" plain name="checkbox-input" style="cursor: pointer"
                              v-b-tooltip.hover class="pull-up custom-control-primary" title="
                                Other
                              " @change="
                                () => {
                                  shipping.pod = '';
                                }
                              " v-model="shipping.portOfDischargeIsInput"></b-form-checkbox>
                          </b-input-group-prepend>
                          <b-form-input v-if="shipping.portOfDischargeIsInput" :disabled="isShow"
                            placeholder="Enter POD" v-model="shipping.pod" />

                          <Select4 v-else v-model="shipping.pod" :disabled="isShow" @select="shippingPOD" style="
                              position: relative;
                              flex: 1 1 auto;
                              min-width: 0;
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                            " class="input-sec" placeholder="Choose POD" :options="{
                              value: 'code',
                              label: 'name',
                              data: ports,
                              fields: [
                                { field: 'code', label: 'Code' },
                                { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                                {
                                  field: 'country_code',
                                  label: 'Country Code',
                                },
                              ],
                            }" />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <!-- Place of Deliver -->
                    <div>
                      <label>Place of Delivery</label>
                      <!-- <b-form-group class="w-100">
                        <b-form-select
                          v-model="shipping.placeOfDelivery"
                          :options="deliver"
                          placeholder="Place of Deliver"
                        />
                      </b-form-group> -->
                      <b-form-group>
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            <b-form-checkbox :disabled="isShow" plain name="checkbox-input" style="cursor: pointer"
                              v-b-tooltip.hover class="pull-up custom-control-primary" title="
                              Other
                              " @change="
                                () => {
                                  shipping.placeOfDelivery = '';
                                }
                              " v-model="shipping.placeOfDeliveryIsInput"></b-form-checkbox>
                          </b-input-group-prepend>
                          <b-form-input v-if="shipping.placeOfDeliveryIsInput" placeholder="Enter Place of Delivery"
                            :disabled="isShow" v-model="shipping.placeOfDelivery" />

                          <Select4 v-else v-model="shipping.placeOfDelivery" :disabled="isShow" style="
                              position: relative;
                              flex: 1 1 auto;
                              min-width: 0;
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                            " class="input-sec" placeholder="Place of Delivery" :options="{
                              value: 'code',
                              label: 'name',
                              data: ports,
                              fields: [
                                { field: 'code', label: 'Code' },
                                { field: 'name', label: 'Name' },
                                {
                                  field: 'country_code',
                                  label: 'Country Code',
                                },
                              ],
                            }" />
                        </b-input-group>
                      </b-form-group>
                    </div>
                    <!-- Payment Terms -->

                    <div>
                      <label>Payment Terms</label>
                      <!-- <v-select
                        placeholder="Payment Terms"
                        label="text"
                        v-model="shipping.paymentTerms"
                        :options="$Options.paymentTerms"
                      /> -->

                      <Select4 v-model="shipping.paymentTerms" :disabled="isShow" style="
                          position: relative;
                          flex: 1 1 auto;
                          min-width: 0;
                          border-top-left-radius: 0;
                          border-bottom-left-radius: 0;
                        " placeholder="Payment Terms" :options="{
                          value: 'id',
                          label: 'text',
                          data: $Options.paymentTerms,
                          hide: true,
                          fields: [{ field: 'text', label: 'Text' }],
                        }" />
                    </div>

                    <!-- B/L type -->
                    <div class="mt-1">
                      <label>B/L type</label>
                      <b-form-group>
                        <!-- <v-select
                          v-model="shipping.BLType"
                          :options="[
                            { id: 'HBL', text: 'HBL' },
                            { id: 'MBL', text: 'MBL' },
                          ]"
                          label="text"
                          placeholder="B/L type"
                        /> -->
                        <Select4 v-model="shipping.BLType" :disabled="isShow" style="
                            position: relative;
                            flex: 1 1 auto;
                            min-width: 0;
                            border-top-left-radius: 0;
                            border-bottom-left-radius: 0;
                          " placeholder="B/L type" :options="{
                            value: 'id',
                            label: 'text',
                            data: [
                              { id: 'HBL', text: 'HBL' },
                              { id: 'MBL', text: 'MBL' },
                            ],
                            hide: true,
                            fields: [{ field: 'text', label: 'Text' }],
                          }" />
                      </b-form-group>
                    </div>
                    <div class="mt-1">
                      <label>Commodity</label>
                      <Select2 placeholder="Commodity" :disabled="isShow" v-model="shipping.commodity"
                        :options="goods_types" />
                    </div>
                    <!-- Description of Goods -->
                    <div class="mt-1">
                      <label>Description of Goods</label>
                      <b-form-group>
                        <b-form-input :disabled="isShow" v-model="shipping.descriptionOfGoods"></b-form-input>
                      </b-form-group>
                    </div>

                    <!-- Shipping mark -->
                    <div class="mt-1">
                      <b-form-group>
                        <label>Shipping mark</label>

                        <b-form-textarea :disabled="isShow" rows="5" v-model="shipping.shippingMark"
                          placeholder="Shipping mark"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <!-- In Word -->
                    <div class="mt-1">
                      <b-form-group>
                        <label>In Word</label>

                        <b-form-textarea :disabled="isShow" rows="5" v-model="shipping.inWord"
                          placeholder="In Word"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <div class="mt-1">
                      <b-form-group>
                        <label>On Board Status</label>
                        <b-form-textarea class="text-center" :disabled="isShow" v-model="shipping.onBoard"
                          :placeholder="shipping.onBoard" rows="5"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <div class="mt-1">
                      <!-- <label>Forwarding agent</label>
                        <b-form-group>
                          <b-form-textarea
                            rows="5"
                            v-model="shipping.forwardingAgent"
                            placeholder="Forwarding agent"
                          ></b-form-textarea>
                        </b-form-group> -->
                      <div class="d-flex mb-1">
                        <b-card-text class="mr-1" :disabled="isShow">Forwarding agent
                        </b-card-text>
                        <Select4 v-model="shipping.forwardingAgent" @select="forwardingAgent_selected"
                          :disabled="isShow" placeholder="Select Company" :options="{
                            value: 'code',
                            label: 'text',
                            data: companyItems,
                            fields: [
                              { field: 'code', label: 'Tax Code' },
                          
                              { field: 'name', label: 'Name' },
                              {
                                field: 'acronym',
                                label: 'Acronym',
                              },
                            ],
                          }" />
                      </div>
                      <b-form-group>
                        <b-form-textarea :disabled="isShow" rows="6" v-model="shipping.forwardingAgentNotes"
                          placeholder="Enter Company"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <b-row>
                      <b-col cols="12" lg="12">
                        <b-form-group label="Place and Date of Issue">
                          <b-input-group>
                            <b-input-group-prepend is-text>
                              <b-form-checkbox :disabled="isShow" plain name="checkbox-input" style="cursor: pointer"
                                v-b-tooltip.hover class="pull-up custom-control-primary" title="
                                  Other
                                " @change="
                                  () => {
                                    shipping.placeAndDate = '';
                                  }
                                " v-model="shipping.placeAndDateIsInput"></b-form-checkbox>
                            </b-input-group-prepend>
                            <b-form-input :disabled="isShow" v-if="shipping.placeAndDateIsInput"
                              v-model="shipping.placeAndDate" />

                            <Select4 v-else v-model="shipping.placeAndDate" :disabled="isShow" style="
                                position: relative;
                                flex: 1 1 auto;
                                min-width: 0;
                                border-top-left-radius: 0;
                                border-bottom-left-radius: 0;
                              " class="input-sec" placeholder="Place of Delivery" :options="{
                                value: 'code',
                                label: 'name',
                                data: ports,
                                fields: [
                                  { field: 'code', label: 'Code' },
                                  { field: 'name', label: 'Name' },
                          { field: 'type', label: 'Service' },
                                  {
                                    field: 'country_code',
                                    label: 'Country Code',
                                  },
                                ],
                              }" />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" lg="12">
                        <b-form-datepicker v-model="shipping.Date" :disabled="isShow" :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }" locale="vi-VN" />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </validation-observer>
          </b-card>
          <b-card>
            <div>
              <vue-good-table :columns="columns_big" :rows="rows_big">
                <template slot="table-row" slot-scope="props">
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'actions'">
                    <feather-icon size="25" :class="isShow ? 'disabled' : ''" class="cursor" icon="TrashIcon"
                      @click="removeItemTable(props.row.id)" />
                  </span>

                  <span v-else-if="props.column.field === 'qty'">
                    <b-form-input :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>

                  <span v-else-if="props.column.field === 'size'">
                    <Select2 v-model="props.row[props.column.field]" :disabled="isShow" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " :settings="{
  allowClear: true,
}" :options="
  cont_types.filter((i) => i.group === 'Container truck')
" />
                  </span>

                  <span v-else-if="props.column.field === 'container'">
                    <b-form-input v-model="props.row[props.column.field]" :disabled="isShow" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>
                  <span v-else-if="props.column.field === 'seal'">
                    <b-form-input :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>

                  <span v-else-if="props.column.field === 'package'">
                    <Select2 :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " :settings="{
  allowClear: true,
}" :options="
  cont_types.filter((i) => i.group === 'packaging')
" />
                  </span>
                  <span v-else-if="props.column.field === 'unit'">
                    <b-form-input :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>
                  <span v-else-if="props.column.field === 'part'">
                    <input type="checkbox" :disabled="isShow" style="width: 20px; height: 20px; margin-top: 9px"
                      @change="
                        changeCell(
                          props.row[props.column.field],
                          props.column.field,
                          props.row.originalIndex
                        )
                      " id="checkbox" v-model="props.row[props.column.field]" />
                    <!-- <b-form-checkbox
                   
                    :value="props.row[props.column.field]"
                    unchecked-value="false"
                  >
                  </b-form-checkbox> -->
                  </span>
                  <span v-else-if="props.column.field === 'gw'">
                    <b-form-input :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>
                  <span v-else-if="props.column.field === 'cbm'">
                    <b-form-input :disabled="isShow" v-model="props.row[props.column.field]" @change="
                      changeCell(
                        props.row[props.column.field],
                        props.column.field,
                        props.row.originalIndex
                      )
                    " type="text"></b-form-input>
                  </span>
                  <!-- Column: Common -->
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
              <div class="flex button text-center mt-2" :class="isShow ? 'disabled' : ''" @click.prevent="addItemTable">
                <feather-icon style="margin-top: -3px" icon="PlusIcon" /> Add
                New Item
              </div>
            </div>
            <b-input-group class="text-center" v-if="!isLoading">
              <label class="mr-1">Attachments</label>
              <vue-dropzone ref="addFileAtt" id="addFileAtt" :options="dropzoneOptions"
                v-on:vdropzone-success="success(1, $event)" :useCustomSlot="true" :class="isShow ? 'disabled' : ''"
                @vdropzone-mounted="vmountedFileAtt" :include-styling="false"
                v-on:vdropzone-file-added="uploadSuccess(1, $event)"
                v-on:vdropzone-error="vdropzoneErrorFileAttachments">
                <div class="dropzone-custom-content">
                  <div>
                    <label class="choose-file">Choose File</label>

                    <span id="file-chosen">{{
                        fileAttachments.name
                          ? fileAttachments.name
                          : "No file chosen"
                    }}
                    </span>
                  </div>
                </div>
              </vue-dropzone>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" style="
                  padding: 0.3rem;
                  position: relative;
                  margin-left: 10px;
                  width: 24px;
                  height: 24px;
                " v-if="fileAttachments.name && isShow" variant="gradient-danger" @click="removeFileAttachments"
                size="sm" class="btn-icon rounded-circle">
                <feather-icon icon="XIcon" size="11" />
              </b-button>
            </b-input-group>

            <b-input-group v-if="!isLoading" class="text-center mt-1">
              <label style="margin-right: 4.3rem">VGM</label>
              <vue-dropzone ref="addFileVGM" id="addFileVGM" :options="dropzoneOptions"
                :class="isShow ? 'disabled' : ''" v-on:vdropzone-success="success(2, $event)" :useCustomSlot="true"
                @vdropzone-mounted="vmountedFileVGM" :include-styling="false"
                v-on:vdropzone-file-added="uploadSuccess(2, $event)" v-on:vdropzone-error="vdropzoneErrorFileVGM">
                <div class="dropzone-custom-content">
                  <div>
                    <label class="choose-file">Choose File</label>
                    <span id="file-chosen">{{
                        fileVGM && fileVGM.name
                          ? fileVGM.name
                          : "No file chosen"
                    }}
                    </span>
                  </div>
                </div>
              </vue-dropzone>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" style="
                  padding: 0.3rem;
                  position: relative;
                  margin-top: 5px;
                  margin-left: 10px;
                  width: 24px;
                  height: 24px;
                " v-if="fileVGM.name && isShow" variant="gradient-danger" @click="removeFileVGM" size="sm"
                class="btn-icon rounded-circle">
                <feather-icon icon="XIcon" size="11" />
              </b-button>
            </b-input-group>
          </b-card>
        </vue-perfect-scrollbar>
      </div>
    </div>
    <b-modal body-class="p-0" size="xl" id="modal-print-wr1" :title="'View Shipping Instruction PDF'"
      :hide-footer="true">
      <vue-pdf-app v-if="pdf" :pdf="pdf" style="height: 85vh" :fileName="currentItem.fileName"
        pageScale="70"></vue-pdf-app>
    </b-modal>
  </div>
</template>
<style>
.modal-body {
  margin-bottom: 20px;
}

.choose-file {
  background-color: #2b938c;
  color: white;
  padding: 0.5rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
}

#file-chosen {
  margin-left: 0.3rem;
  font-family: sans-serif;
}

.button {
  cursor: pointer;
  padding: 11px 24px;
  border-radius: 30px;
  border: none;
  font-size: 12px;
  margin-top: 8px;
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  background-color: #2b938c;
  align-items: center;
  justify-content: center;
  width: 30rem;
}

.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}

.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}

.red {
  color: red;
}

.vue-dropzone>.dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}

.table-print {
  border-collapse: collapse !important;
  width: 100%;
  border: 1px solid #333 !important;
}

.table-print td {
  text-align: left;
}

.table-print th {
  text-align: center;
}

.table-print td,
.table-print th {
  border-bottom: 1px solid #333 !important;
  border-right: 1px solid #333 !important;
  padding: 4px 6px;
}

.table-print th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #2b938c;
  color: white;
}

.modal-footer .btn {
  width: auto !important;
}
</style>
<script>
import Ripple from "vue-ripple-directive";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {
  BAvatar,
  BForm,
  BFormTextarea,
  BImg,
  BDropdown,
  BDropdownItem,
  BButton,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueGoodTable } from "vue-good-table";
import { $ctx } from "@themeConfig";
import VueHtml2pdf from "vue-html2pdf";
import Vue from "vue";
import PrintCost from "./PrintCost.vue";
import NewShipmentOnFast from "./NewShipmentOnFast.vue";
import NewShipmentOnTms from "./NewShipmentOnTms.vue";
import NProgress from "nprogress";
import vSelect from "vue-select";
import { mapState, mapActions } from "vuex";
import { setTimeout } from "timers";
import PrintShippingInstruction from "./PrintShippingInstruction.vue";
import "vue-pdf-app/dist/icons/main.css";
import VuePdfApp from "vue-pdf-app";
export default {
  props: {
    readonly: { default: false, type: Boolean },
    view_quotation: { default: null },
    request_quotation: { default: null },
    isCustomer: { default: null },
    booking: { default: null },
    costs_info: { default: null },
    step: { default: null },
    serviceType: { default: null },
  },
  directives: {
    Ripple,
  },
  components: {
    VuePdfApp,
    PrintShippingInstruction,
    NewShipmentOnTms,
    NewShipmentOnFast,
    VueGoodTable,
    BAvatar,
    BForm,
    PrintCost,
    BImg,
    VueHtml2pdf,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTextarea,
    ValidationProvider,
    BCardText,
    ValidationObserver,
    BFormInput,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
    vSelect,
  },
  data() {
    return {
      pdf: null,
      isLoading: true,
      moment,
      userData: JSON.parse(localStorage.getItem("userData")),
      attachFiles: [],
      VGMFiles: [],
      shipping: {
        id: "",
        bookingID: "",
        placeAndDateIsInput: false,
        vesselIsInput: false,
        placeOfReceiptIsInput: false,
        portOfLoadingIsInput: false,
        portOfDischargeIsInput: false,
        placeOfDeliveryIsInput: false,
        commodityIsInput: false,
        shippingTermIsInput: false,
        vessel: "",
        placeOfReceipt: "",
        pol: "",
        pod: "",
        etd: "",
        podName: "",
        placeOfDelivery: "",
        shippingTerm: "",
        BLType: "",
        commodity: "",
        descriptionOfGoods: "",
        shippingMark: "",
        inWord: `"SHIPPER'S LOAD, COUNT & SEAL"\n"SAID TO CONTAIN"`,
        onBoard: `CLEAN ON BOARD`,
        forwardingAgent: "",
        placeAndDate: "",
      },

      shipperSelected: "",
      consigneeSelected: "",
      notifySelected: "",

      notify: {
        notifyCopy: false,
        notifySelected: "",
      },
      shipper: {
        shipperSelected: "",
        notes: ``,
      },
      fileAttachments: {},
      fileVGM: {},

      code: null,
      freights: [
        { id: "Prepaid", text: "Prepaid" },
        { id: "Collect", text: "Collect" },
      ],

      consignee: {
        consigneeSelected: "",
      },
      updateFilesAttProcessed: false,
      updateFilesVGMProcessed: false,

      isHideShow: false,
      isHideShowPk: false,
      appLogoImage: require("@/assets/images/logo/logo.svg"),
      shipping_lines: [],
      currentItem: {},
      fee_types: null,
      isDraft: false,
      // companyItems:null,
      unit_types: null,
      columns_big: [
        {
          label: "Q`ty",
          field: "qty",

          sortable: false,
        },
        {
          label: "Size",
          field: "size",
          width: "200px",

          sortable: false,
        },
        {
          label: "Container No.",
          field: "container",
          sortable: false,
        },
        {
          label: "Seal No.",
          field: "seal",
          sortable: false,
        },
        {
          label: "Package",
          field: "package",
          sortable: false,
          width: "200px",
        },
        {
          label: "Unit",
          field: "unit",
          type: "number",

          sortable: false,
        },
        {
          label: "Part",
          sortable: false,
          tdClass: "text-center",
          field: "part",
        },
        {
          label: "GW",
          field: "gw",
          sortable: false,
        },
        {
          label: "CBM",
          field: "cbm",
          sortable: false,
        },
        {
          field: "actions",
          sortable: false,
        },
      ],
      rows_big: [
        {
          id: 1,
          qty: "",
          Size: "",
          container: "",
          seal: "",
          package: "",
          unit: "",
          part: true,
          gw: "",
          cbm: "",
        },
      ],
      columns: [
        {
          label: "Type",
          field: "type",
          sortable: false,
        },
        {
          label: "Region",
          field: "region",
          sortable: false,
        },
        {
          label: "PIC",
          field: "pic",
          width: "200px",
          sortable: false,
        },
        {
          label: "Tel",
          width: "170px",
          field: "tel",
          sortable: false,
        },
        {
          label: "Email",
          width: "190px",
          field: "email",
          sortable: false,
        },
      ],
      rows_ship: [
        {
          company: "",
          type: "Shipper",
          region: "",
          pic: "",
          tel: "",
          email: "",
        },
        {
          company: "",
          type: "Consignee",
          region: "",
          pic: "",
          tel: "",
          email: "",
        },
        {
          company: "",
          type: "Notify",
          region: "",
          pic: "",
          tel: "",
          email: "",
        },
      ],

      rows_ship_table: [
        {
          company: "",
          type: "Shipper",
          region: "",
          pic: "",
          tel: "",
        },
        {
          company: "",
          type: "Shipper",
          region: "",
          pic: "",
          tel: "",
        },
        {
          company: "",
          type: "Consignee",
          region: "",
          pic: "",
          tel: "",
        },
        {
          company: "",
          type: "Consignee",
          region: "",
          pic: "",
          tel: "",
        },
        {
          company: "",
          type: "Notify",
          region: "",
          pic: "",
          tel: "",
        },
        {
          company: "",
          type: "Notify",
          region: "",
          pic: "",
          tel: "",
        },
      ],
      isShow: false,
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        previewsContainer: false,
        autoProcessQueue: false,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        headers: { apiKey: localStorage.getItem("accessToken") },
      },
      isDraftSave: false,
      tempShipping: {},
      tempDraftKH: {},
      tempDraftSALE: {},
      tempDraftAdmin: {},
      viewDraft: false,
      fileDeleted: [],
      valueProgress: 0,
    };
  },
  created() {
    this.$store.dispatch("masterData/fetchPort");
    this.$store.dispatch("masterData/fetchCountries");

    this.readonlyFrom = this.readonly;
  },
  watch: {
    "notify.notifyCopy"(n) {
      if (n) {
        this.notify.notes = this.consignee.notes;
      }
    },
    valueProgress(val) {
      if (val == 100) this.$loading.hide();
    },
  },

  mounted() {
    setTimeout(() => {
      useJwt
        .get("wr1?objectType=ShippingInstruction", {
          params: { search: { bookingId: this.request_quotation.bookingID } },
        })
        .then((response) => {
          if (
            response.data.result &&
            response.data.result[0].shipping_instruction != ""
          ) {
            const data = JSON.parse(
              response.data.result[0].shipping_instruction
            );

            this.mountedData(data);
          } else {

            if (this.request_quotation && this.request_quotation.accept_edit != 1 && this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale) {
              this.isShow = true
            }
            this.shipping.typeSubmit = null;
            this.shipping.id = this.request_quotation.bookingID;

            this.shipping.bookingID = this.request_quotation.bookingID;
            this.shipping.etd = this.request_quotation.shipment_on_fast.etd;
            this.shipping.pol =
              this.request_quotation.shipment_on_fast.pol_port;
            this.shipping.pod =
              this.request_quotation.shipment_on_fast.pod_port;

            this.shipping.placeOfDelivery =
              this.request_quotation.shipment_on_fast.placeOfDelivery;

            this.shipping.paymentTerms = this.request_quotation.paymentTerms;

            this.shipping.commodity =
              this.request_quotation.shipment_on_fast.goods_type;
            this.shipping.descriptionOfGoods =
              this.request_quotation.shipment_on_fast.mo_ta;

            this.rows_big[0].gw =
              this.request_quotation.shipment_on_fast.trong_luong;
            this.rows_big[0].cbm =
              this.request_quotation.shipment_on_fast.so_khoi;

            this.rows_big[0].part =
              this.request_quotation.service_type == 3 ? true : false;

            const dataShipper = this.companyItems.find(
              (e) =>
                e.fast_id == this.request_quotation.shipment_on_fast.shipper
            );

            if (dataShipper) {
              this.shipper.shipperSelected = dataShipper.id;
              this.shipper.notes = `${dataShipper.name}
${dataShipper.address}`;
            }

            const dataConsignee = this.companyItems.find(
              (e) =>
                e.fast_id == this.request_quotation.shipment_on_fast.consignee
            );
            if (dataConsignee) {
              this.consignee.consigneeSelected = dataConsignee?.id;
              this.consignee.notes = `${dataConsignee.name}
${dataConsignee.address}`;
            }

            this.shipping.onBoard = `CLEAN ON BOARD \n ${this.request_quotation.pod ? this.request_quotation.pod : ""
              }\n ${this.request_quotation.etd
                ? moment(this.request_quotation.etd).format("DD.MM.YYYY")
                : ""
              }`;

            this.tempShipping = JSON.parse(
              JSON.stringify({
                id: this.shipping.id,
                shipper: { ...this.shipper },
                consignee: { ...this.consignee },
                notify: { ...this.notify },
                shipping: this.shipping,
                ship_table: this.rows_ship_table,
                detail: this.rows_big,
                attachFiles: this.attachFiles,
                VGMFiles: this.VGMFiles,
              })
            );
          }
        })
        .finally(() => (this.isLoading = false));
    }, 500);
  },
  // thành add
  computed: {
    ...mapState("masterData", [
      "companyItems",
      "sales",
      "ports",
      "regions",
      "incoterms",
      "goods_types",
      "countries",
      "cont_types",
      "vessel",
    ]),
  },
  // thanh add
  methods: {
    onProgress(event) {
      if (event == 100) {
        this.$loading.hide();
      }
      // console.log(`Processed: ${event} / 100`);
    },
    genDataJaper() {
      var vm = this;

      return {
        P_HBL_DATA: "",
        P_SHIPPER: this.shipper.notes ? this.shipper.notes : this.shipper.notes,
        P_CONSIGNEE: this.consignee.notes ? this.consignee.notes : "",
        P_NOTIFY: this.notify.notes ? this.notify.notes : "",
        P_PLACE_OF_RECEIPT_DATA: this.shipping.placeOfReceiptIsInput
          ? this.shipping.placeOfReceipt
          : this.ports.find((e) => e.name == this.shipping.placeOfReceipt)
            ?.name || "",
        P_VESSEL_VOYAGE_DATA: this.shipping.vesselIsInput
          ? this.shipping.vessel
          : this.shipping.vessel
            ? this.vessel.find((e) => e.code == this.shipping.vessel)?.name || ""
            : "",
        P_POL_DATA: this.shipping.portOfLoadingIsInput
          ? this.shipping.pol
          : this.shipping.pol
            ? this.ports.find((e) => e.name == this.shipping.pol)?.name || ""
            : "",
        P_POD_DATA: this.shipping.portOfDischargeIsInput
          ? this.shipping.pod
          : this.shipping.pod
            ? this.ports.find((e) => e.name == this.shipping.pod)?.name || ""
            : "",

        P_PLACE_OF_DELIVERY_DATA: this.shipping.placeOfDeliveryIsInput
          ? this.shipping.placeOfDelivery
          : this.shipping.placeOfDelivery
            ? this.ports.find((e) => e.name == this.shipping.placeOfDelivery)
              ?.name || ""
            : "",

        P_JSON_DATA: JSON.stringify(
          this.rows_big.map((item) => {
            var jsonNew = {};

            jsonNew.CONTAINER_SEAL_NO = item.container + "" + item.seal;
            jsonNew.UNIT_PACKAGE =
              item.unit + "" + item[`package`]
                ? vm.cont_types.find((e) => e.code == item[`package`])?.name ||
                ""
                : "";
            jsonNew.DESCRIPTION_OF_GOODS = "";
            jsonNew.GW =
              item.gw && typeof item.gw !== "undefined" ? item.gw : "";
            jsonNew.CBM =
              item.cbm && typeof item.cbm !== "undefined" ? item.cbm : "";
            return jsonNew;
          })
        ).toString(),
        P_SHIPPING_MARKS:
          this.shipping.shippingMark &&
            typeof this.shipping.shippingMark !== "undefined"
            ? this.shipping.shippingMark
            : "",
        P_ON_BOARD_STATUS:
          this.shipping.onBoard && typeof this.shipping.onBoard !== "undefined"
            ? this.shipping.onBoard
            : "",
        P_IN_WORD:
          this.shipping.inWord && typeof this.shipping.inWord !== "undefined"
            ? this.shipping.inWord
            : "",
        P_PAYMENT_TERMS: this.shipping.paymentTerms
          ? this.$Options.paymentTerms.find(
            (e) => e.code == this.shipping.paymentTerms
          )?.name || ""
          : "",
        P_PLACE_AND_DATE_OF_ISSUE:
          (this.shipping.placeAndDateIsInput
            ? this.shipping.placeAndDate
            : this.shipping.placeAndDate
              ? this.ports.find((e) => e.name == this.shipping.placeAndDate)
                ?.name || ""
              : "") +
            "" +
            this.shipping.Date && typeof this.shipping.Date !== "undefined"
            ? this.shipping.Date
            : "",

        P_AGENT_DATA:
          this.shipping.forwardingAgentNotes &&
            typeof this.shipping.forwardingAgentNotes !== "undefined"
            ? this.shipping.forwardingAgentNotes
            : "",
      };
    },
    async generateReport() {
      this.isLoading = true;

      var data = this.genDataJaper();

      useJwt
        .post(
          "jasper",
          {
            j_type: "pdf",
            j_report: "SHIPPING_INSTRUCTION",
            j_scr: "default",
            j_name: "SHIPPING_INSTRUCTION",
            ...data,
          },
          { responseType: "arraybuffer" }
        )
        .then((response) => {

          this.pdf = response.data;

          this.$bvModal.show("modal-print-wr1");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi lấy dữ liệu, vui lòng thử lại!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          this.$loading.hide();
        });
    },
    isShowData(type) {

      if (
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin &&
        type == 0
      ) {
        this.isShow = true;
      } else if (
        ((this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale &&
          type == 1) ||
          type == 0)
      ) {
        this.isShow = true;
      } else if (
        (this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client ||
          this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Client_Root) &&
        type != null
      ) {
        this.isShow = true;
      }




    },
    mountedData(data) {

      this.shipping.typeSubmit = data.typeSubmit;
      this.shipping.id = data.id;
      this.shipping = data.shipping;
      this.shipper = data.shipper;
      this.consignee = data.consignee;
      this.notify = data.notify;
      this.ship_table = data.ship_table;
      this.rows_big = data.detail;
      // this.tempDraft = data.dataDraft;
      if (this.shipping.typeSubmit) {
      }
      if (!this.viewDraft) {
        this.isShowData(data.typeSubmit);

        this.tempDraftKH = data.dataDraftKH;
        this.tempDraftAdmin = data.dataDraftAdmin;
        this.tempDraftSALE = data.dataDraftSALE;
        this.tempShipping = JSON.parse(
          JSON.stringify({
            id: this.shipping.id,
            shipper: { ...this.shipper },
            consignee: { ...this.consignee },
            notify: { ...this.notify },
            shipping: this.shipping,
            ship_table: this.rows_ship_table,
            detail: this.rows_big,
            attachFiles: this.attachFiles,
            VGMFiles: this.VGMFiles,
          })
        );
      }
      if (data.attachFiles.length > 0) {
        this.attachFiles = data.attachFiles;
      } else {
        // this.$refs.addFileAtt.removeFile(true);
        this.fileAttachments = {};
        this.attachFiles = [];
      }

      if (data.VGMFiles.length > 0) {
        this.VGMFiles = data.VGMFiles;

        this.VGMFiles[0].download_path =
          $ctx.API_URL +
          "uploadFile/" +
          data.VGMFiles[0].path +
          "?apiKey=" +
          localStorage.getItem("accessToken") +
          "&name=" +
          data.VGMFiles[0].name;
      } else {
        // this.$refs.addFileVGM.removeFile(true);
        this.fileVGM = {};
        this.VGMFiles = [];
      }
      if (this.request_quotation && this.request_quotation.accept_edit != 1 && this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale) {
        this.isShow = true
      }
      return true;
    },
    vmountedFileAtt() {
      this.$nextTick(function () {
        if (this.attachFiles.length > 0) {
          this.attachFiles[0].download_path =
            $ctx.API_URL +
            "uploadFile/" +
            this.attachFiles[0].path +
            "?apiKey=" +
            localStorage.getItem("accessToken") +
            "&name=" +
            this.attachFiles[0].name;
          // console.log(this.$refs.addFileAtt);
          this.$refs.addFileAtt.manuallyAddFile(
            this.attachFiles[0],
            this.attachFiles[0].download_path
          );
        }
      });
    },
    vmountedFileVGM() {
      this.$nextTick(function () {
        if (this.VGMFiles.length > 0) {
          this.$refs.addFileVGM.manuallyAddFile(
            this.VGMFiles[0],
            this.VGMFiles[0].download_path
          );
        }
      });
    },
    shippingPOD(e) {
      this.shipping.onBoard = `CLEAN ON BOARD
${e.text}
${this.shipping.etd ? this.shipping.etd : ""}
      `;
    },
    shipper_selected(e) {
      if (!this.$Utils.isBlank(e)) {
        this.shipper.notes = `${e.name}
${e.address}
`;
      } else {
        this.shipper.notes = ``;
      }
    },

    consignee_selected(e) {
      if (!this.$Utils.isBlank(e)) {
        this.consignee.notes = `${e.name}
${e.address}
`;
      } else {
        this.consignee.notes = ``;
      }
    },

    notify_selected(e) {
      if (!this.$Utils.isBlank(e)) {
        this.notify.notes = `${e.name}
${e.address}
`;
      } else {
        this.notify.notes = ``;
      }
    },
    forwardingAgent_selected(e) {
      if (!this.$Utils.isBlank(e)) {
        this.shipping.forwardingAgentNotes = `${e.name}
${e.address}
`;
      } else {
        this.shipping.forwardingAgent = ``;
      }
    },

    removeFileAttachments() {
      this.fileDeleted.push(this.attachFiles[0]);
      this.$refs.addFileAtt.removeFile(true);
      this.fileAttachments = {};
      this.attachFiles = [];
    },

    removeFileVGM() {
      this.fileDeleted.push(this.VGMFiles[0]);
      this.$refs.addFileVGM.removeFile(true);

      this.fileVGM = {};
      this.VGMFiles = [];
    },

    vdropzoneErrorFileVGM(file, errorMessage) {
      this.$refs.addFileVGM.removeFile(file);
      this.removeFileVGM();
      if (errorMessage.code == 401) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: "Phiên đăng nhập hết hạn vui lòng F5 lại.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    vdropzoneErrorFileAttachments(file, errorMessage) {
      this.$refs.addFileAtt.removeFile(file);
      this.removeFileAttachments();
      if (errorMessage.code == 401) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: "Phiên đăng nhập hết hạn vui lòng F5 lại.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    uploadSuccess: function (type, file) {
      if (type == 1) {
        this.fileAttachments = {};
        if (file) {
          this.fileAttachments.name = file.name;
        }
      } else {
        this.fileVGM = {};

        if (file) {
          this.fileVGM.name = file.name;
        }
      }
    },

    changeCellShipTable(changedData, column, row) {
      this.rows_ship_table[row][column] = changedData;
    },

    changeCell(changedData, column, row) {
      this.rows_big[row][column] = changedData;
    },
    removeItemTable(id) {
      this.rows_big = this.rows_big.filter((e) => e.id !== id);
    },
    addItemTable() {
      this.rows_big.push({
        id: Math.floor(Math.random() * Math.pow(10, 15)),
        qty: "",
        size: "",
        container: "",
        seal: "",
        package: "",
        unit: "",
        part: false,
        gw: "",
        cbm: "",
      });
    },
    hideShowsi: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },

    async handIsDraft() {
      if (this.viewDraft) {
        this.isLoading = true;
        await this.mountedData(this.tempShipping);
        this.isLoading = false;
        this.viewDraft = false;
      } else if (
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin
      ) {
        this.isLoading = true;
        this.viewDraft = true;
        await this.mountedData(this.tempDraftAdmin);
        this.isLoading = false;
      } else if (
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
      ) {
        this.isLoading = true;
        this.viewDraft = true;
        await this.mountedData(this.tempDraftSALE);
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.viewDraft = true;
        await this.mountedData(this.tempDraftKH);
        this.isLoading = false;
      }
    },
    async handSaveDraft() {
      this.isDraftSave = true;
      this.updateFiles();
    },
    updateFiles: function () {
      if (this.$refs.addFileAtt.getQueuedFiles().length) {
        this.updateFilesAttProcessed = true;
        this.$refs.addFileAtt.processQueue();
      }
      if (this.$refs.addFileVGM.getQueuedFiles().length) {
        this.updateFilesVGMProcessed = true;

        this.$refs.addFileVGM.processQueue();
      }

      if (
        this.$refs.addFileAtt.getQueuedFiles().length == 0 &&
        this.$refs.addFileVGM.getQueuedFiles().length == 0
      ) {
        this.putDataShippingInfo();
      }
    },
    processFiles() {
      this.updateFiles();
    },
    success: function (type, file) {
      if (type == 1) {
        var fileSuccess = JSON.parse(file.xhr.response).result;
        fileSuccess.type = file.type;
        fileSuccess.size = file.size;
        fileSuccess.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        fileSuccess.uuid = file.upload.uuid;
        fileSuccess.fullName = this.userData.fullName;
        fileSuccess.username = this.userData.username;

        this.attachFiles.push(fileSuccess);
        this.updateFilesAttProcessed = false;
      } else {
        var fileSuccess = JSON.parse(file.xhr.response).result;
        fileSuccess.type = file.type;
        fileSuccess.size = file.size;
        fileSuccess.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        fileSuccess.uuid = file.upload.uuid;
        fileSuccess.fullName = this.userData.fullName;
        fileSuccess.username = this.userData.username;

        this.VGMFiles.push(fileSuccess);
        this.updateFilesVGMProcessed = false;
      }

      if (!this.updateFilesAttProcessed && !this.updateFilesVGMProcessed) {
        // console.log("A file was successfully uploaded");

        this.putDataShippingInfo();
      }
    },
    putDataShippingInfo() {
      var shippingInfo = {};
      if (this.isDraftSave) {
        if (this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin) {
          this.tempDraftAdmin = {
            id: this.shipping.id,
            shipper: { ...this.shipper },
            consignee: { ...this.consignee },
            notify: { ...this.notify },
            shipping: this.shipping,
            ship_table: this.rows_ship_table,
            detail: this.rows_big,
            attachFiles: this.attachFiles,
            VGMFiles: this.VGMFiles,
          };
        } else if (
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
        ) {
          this.tempDraftSALE = {
            id: this.shipping.id,
            shipper: { ...this.shipper },
            consignee: { ...this.consignee },
            notify: { ...this.notify },
            shipping: this.shipping,
            ship_table: this.rows_ship_table,
            detail: this.rows_big,
            attachFiles: this.attachFiles,
            VGMFiles: this.VGMFiles,
          };
        } else {
          this.tempDraftKH = {
            id: this.shipping.id,
            shipper: { ...this.shipper },
            consignee: { ...this.consignee },
            notify: { ...this.notify },
            shipping: this.shipping,
            ship_table: this.rows_ship_table,
            detail: this.rows_big,
            attachFiles: this.attachFiles,
            VGMFiles: this.VGMFiles,
          };
        }

        shippingInfo = {
          ...this.tempShipping,
          id: this.shipping.id,
          dataDraftKH: this.tempDraftKH,
          dataDraftAdmin: this.tempDraftAdmin,
          dataDraftSALE: this.tempDraftSALE,
        };
      } else {
        var typeSubmit = null;
        if (this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin) {
          typeSubmit = 0;
        } else if (
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
        ) {
          typeSubmit = 1;
        } else {
          typeSubmit = 2;
        }

        shippingInfo = {
          typeSubmit: typeSubmit,
          id: this.shipping.id,
          shipper: { ...this.shipper },
          consignee: { ...this.consignee },
          notify: { ...this.notify },
          shipping: this.shipping,
          ship_table: this.rows_ship_table,
          detail: this.rows_big,
          attachFiles: this.attachFiles,
          VGMFiles: this.VGMFiles,
          dataDraftKH: {},
          dataDraftAdmin: typeSubmit == 0 ? {} : this.tempDraftAdmin,
          dataDraftSALE: typeSubmit == 2 ? this.tempDraftSALE : {},
        };
      }
      if (this.fileDeleted.length > 0) {
        this.fileDeleted.forEach((element) => {
          const bookingId = "-1";
          this.$store.dispatch("attachFile/deleteFile", {
            bookingId,
            type_delete: "3",
            path: element.path,
          });
        });
      }
      useJwt
        .put("wr1?objectType=UpdateShippingInstruction", shippingInfo)
        .then((response) => {
          if (response.data.result == 1) {
            this.$emit("RequestAnUpdateEvent");
          }
        });
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";

.hide_select {
  display: block;
  width: 70%;
}

.cursor {
  cursor: pointer;
}

.hide_input {
  display: none;
}

.hide_show .hide_input {
  display: block;
}

.hide_input {
  width: 100%;
}

.hide_show .hide_select {
  display: none;
}

.hide_select {
  width: 80%;
}

.check_input {
  width: 10%;
  margin-left: 30px;
}

.input-sec .vs__dropdown-toggle,
.input-sec .input-selection {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.mx-input,
.form-control .custom-select {
  border: 1px solid #aaa;
}

.vs__search::placeholder {
  color: #aaa;
  opacity: 1;
  /* Firefox */
}

.vs__search:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #aaa;
}

.vs__search::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #aaa;
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    max-width: 95% !important;
  }
}

@media (min-width: 576px) {

  .modal-lg,
  .modal-xl {
    max-width: 98% !important;
  }
}
</style>